import { AppointmentsFilter, CoachConversation, Nudge } from '@grow-therapy-team/seedling-components';

import { Exact, InputMaybe, Maybe } from '../../types';

// Types for IntersessionSummary consolidated query
export type IntersessionSummary__ProgressNoteItem = {
  label: string;
  item: string;
};

export type IntersessionSummary__IntakePreVisitSummaryContent = {
  __typename: 'IntakePreVisitSummaryContentObject';
  generatedCoachTopics?: Maybe<string[]>;
  coachConversationCount?: Maybe<number>;
  currentPhqCategory?: Maybe<string>;
  currentGadCategory?: Maybe<string>;
};

export type IntersessionSummary__FollowUpPreVisitSummaryContent = {
  __typename: 'FollowUpPreVisitSummaryContentObject';
  progressNote?: Maybe<IntersessionSummary__ProgressNoteItem[]>;
  reflectionTopics?: Maybe<string[]>;
  completedResources?: Maybe<string[]>;
  generatedCoachTopics?: Maybe<string[]>;
  coachConversationCount?: Maybe<number>;
  currentPhqCategory?: Maybe<string>;
  currentPhq?: Maybe<number>;
  previousPhqCategory?: Maybe<string>;
  previousPhq?: Maybe<number>;
  currentGadCategory?: Maybe<string>;
  currentGad?: Maybe<number>;
  previousGadCategory?: Maybe<string>;
  previousGad?: Maybe<number>;
};

export type IntersessionSummary__PreVisitSummary = {
  createdAt: string;
  content?: Maybe<
    IntersessionSummary__IntakePreVisitSummaryContent | IntersessionSummary__FollowUpPreVisitSummaryContent
  >;
};

export type IntersessionSummary__Patient = {
  id: string;
  shortId: string;
  hasCompletedMeasureResponses: boolean;
  firstName: string;
  preferredFullName: string;
  pronouns?: Maybe<string>;
  clientUser: {
    shortId: string;
  };
  nudges?: Maybe<Nudge[]>;
  unreadSafetyConcernConversation?: Maybe<CoachConversation>;
};

export type IntersessionSummary__RecurringAppointmentGrouping = {
  indefinite?: Maybe<boolean>;
  recurringAppointmentGroupingId?: Maybe<string>;
  weeksBetween?: Maybe<number>;
  recurrenceRule?: Maybe<string>;
  version?: Maybe<number>;
  appointments?: Maybe<Array<{ id: string; timeStart: string }>>;
};

export type IntersessionSummary__Appointment = {
  id: string;
  appointmentShortId: string;
  appointmentType: string;
  timeStart: string;
  timeEnd: string;
  inOffice?: Maybe<boolean>;
  patient?: Maybe<IntersessionSummary__Patient>;
  recurringAppointmentGrouping?: Maybe<IntersessionSummary__RecurringAppointmentGrouping>;
  preVisitSummary?: Maybe<IntersessionSummary__PreVisitSummary>;
};

export type IntersessionSummary__AppointmentEdge = {
  __typename?: 'AppointmentObjectEdge';
  node?: Maybe<IntersessionSummary__Appointment>;
};

export type IntersessionSummary__AppointmentsConnection = {
  __typename?: 'AppointmentObjectConnection';
  edges: Array<Maybe<IntersessionSummary__AppointmentEdge>>;
};

export type IntersessionSummary__Provider = {
  __typename?: 'Provider';
  id: string;
  providerShortId: string;
  shortId: string;
  providerAppointments?: Maybe<IntersessionSummary__AppointmentsConnection>;
};

export type IntersessionSummaryConnected__GetUpcomingAppointmentForPatientQuery = {
  __typename?: 'Query';
  currentProvider?: Maybe<IntersessionSummary__Provider>;
};

export type IntersessionSummaryConnected__GetUpcomingAppointmentForPatientQueryVariables = Exact<{
  filters?: InputMaybe<AppointmentsFilter>;
  sort?: InputMaybe<Array<string>>;
}>;

// Types for GetCoachAccessInfo query
export enum CoachUserType {
  CLIENT_USER = 'CLIENT_USER',
  PROVIDER = 'PROVIDER',
}

export enum CoachDisabledByType {
  NOT_RELEASED_TO_USER = 'NOT_RELEASED_TO_USER',
}

export type GetCoachAccessInfo__DisabledReason = {
  disabledByType?: Maybe<CoachDisabledByType>;
};

export type GetCoachAccessInfo__CoachAccess = {
  userId: string;
  userType: CoachUserType;
  canUpdateAccess: boolean;
  enabled: boolean;
  disabledReasons?: Maybe<GetCoachAccessInfo__DisabledReason[]>;
};

export type GetCoachAccessInfoQuery = {
  __typename?: 'Query';
  coachAccess?: Maybe<GetCoachAccessInfo__CoachAccess>;
};

export type GetCoachAccessInfoQueryVariables = Exact<{
  userId: string;
  userType?: InputMaybe<CoachUserType>;
}>;
